import React from "react";
import { Check, Loader2, Save } from "lucide-react";

function SaveConnectionBar({ isSetupMode, saved, saving, disabled, onSave }) {
  return (
  <div className="flex flex-col gap-3 rounded-[20px] border border-[#d8e7ed] bg-white px-4 py-4 shadow-[0_12px_35px_rgba(15,43,66,0.05)] sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-5 dark:border-dark-border dark:bg-dark-card">
    
    {/* Message */}
    <div className="min-w-0 flex-1">
      {saved ? (
        <div className="flex min-w-0 items-center gap-2">
          <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-theme-100 text-primary dark:bg-dark-soft-blue dark:text-dark-primary">
            <Check size={12} />
          </div>

          <div className="min-w-0">
            <p className="truncate text-[10px] font-semibold text-text-primary sm:text-xs dark:text-dark-text-primary">
              {isSetupMode ? "Setup completed" : "Changes saved"}
            </p>

            <p className="mt-0.5 line-clamp-2 text-[9px] leading-4 text-text-muted sm:text-[10px] dark:text-dark-text-muted">
              {isSetupMode
                ? "Your WhatsApp connection is ready."
                : "Your active WhatsApp connection has been updated."}
            </p>
          </div>
        </div>
      ) : (
        <div className="min-w-0">
          <p className="truncate text-[10px] font-semibold text-text-primary sm:text-xs dark:text-dark-text-primary">
            {isSetupMode ? "Complete setup" : "Save configuration"}
          </p>

          <p className="mt-0.5 line-clamp-2 text-[9px] leading-4 text-text-muted sm:text-[10px] dark:text-dark-text-muted">
            {isSetupMode
              ? "Save your WhatsApp connection to continue to the dashboard."
              : "This connection will be used across your dashboard."}
          </p>
        </div>
      )}
    </div>

    {/* Save Button */}
    <button
      type="button"
      onClick={onSave}
      disabled={saving || disabled}
    className="inline-flex h-10 w-full shrink-0 items-center justify-center gap-2 rounded-xl bg-[#147db5] px-4 text-[10px] font-bold text-white shadow-[0_9px_22px_rgba(20,125,181,0.20)] transition-all hover:bg-[#0f5b8a] disabled:cursor-not-allowed disabled:opacity-40 sm:w-auto sm:px-5 sm:text-[11px] dark:bg-dark-primary dark:hover:bg-dark-primary-hover"
    >
      {saving ? (
        <>
          <Loader2
            size={13}
            className="animate-spin sm:hidden"
          />

          <Loader2
            size={14}
            className="hidden animate-spin sm:block"
          />

          Saving...
        </>
      ) : saved ? (
        <>
          <Check
            size={13}
            className="sm:hidden"
          />

          <Check
            size={14}
            className="hidden sm:block"
          />

          {isSetupMode ? "Setup complete" : "Saved"}
        </>
      ) : (
        <>
          <Save
            size={13}
            className="sm:hidden"
          />

          <Save
            size={14}
            className="hidden sm:block"
          />

          {isSetupMode ? "Complete setup" : "Save changes"}
        </>
      )}
    </button>
  </div>
);
}

export default SaveConnectionBar;
